<template>
	<error-page status="404" title="We can't find the page you're looking for">
		<p>
			The page you're trying to access doesn't appear to exist.
		</p>
		<btn primary raised @click="goBack">Go back</btn>
	</error-page>
</template>


<script>
	export default {
		name: 'not-found',
		methods: {
			goBack() {
				this.$router.go(-1);
			}
		}
	};
</script>